// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-f4155712] .el-dialog {\n  max-width: 1000px;\n}", ""]);
// Exports
module.exports = exports;
